import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#B20FC0",
      "fill-rule": "evenodd",
      d: "M5.543 10.543a1 1 0 0 1 1.414 0L15 18.586l8.043-8.043a1 1 0 0 1 1.414 1.414l-8.75 8.75a1 1 0 0 1-1.414 0l-8.75-8.75a1 1 0 0 1 0-1.414Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "chevron-down"}) } }